import type { StudentWithSummary } from '../../types/studentSummary'
import RosterFilterBar from './RosterFilterBar'
import type { RosterFilterValue } from './RosterFilterBar'

interface StudentListFiltersProps {
  schoolId: string
  value: RosterFilterValue
  onFilterChange: (filters: RosterFilterValue) => void
  onCSVExport: () => void
  onManageGroups?: () => void
  students: StudentWithSummary[]
}

const StudentListFilters = ({
  schoolId,
  value,
  onFilterChange,
  onCSVExport,
  onManageGroups,
  students
}: StudentListFiltersProps) => (
  <RosterFilterBar
    schoolId={schoolId}
    value={value}
    onChange={onFilterChange}
    rightSlot={
      <>
        {onManageGroups && (
          <button
            onClick={onManageGroups}
            className="px-4 py-2 text-sm font-medium rounded-md bg-purple-600 text-white hover:bg-purple-700 transition-colors duration-200 whitespace-nowrap"
          >
            グループを管理
          </button>
        )}
        <button
          onClick={onCSVExport}
          disabled={students.length === 0}
          className={`px-4 py-2 text-sm font-medium rounded-md transition-colors duration-200 whitespace-nowrap ${
            students.length === 0
              ? 'bg-gray-300 text-gray-500 cursor-not-allowed'
              : 'bg-green-600 text-white hover:bg-green-700'
          }`}
        >
          CSVダウンロード
        </button>
      </>
    }
  />
)

export default StudentListFilters
